import React, {useRef, useEffect} from 'react'

const SvgRender = ({svg, id}) => {
    const svgWrapperRef = useRef();
    useEffect(() => {
        svgWrapperRef.current.innerHTML = svg;
        return 
    }, [svg])    

    return <div ref={svgWrapperRef} id={id} />

}

export default SvgRender;